var TOKENS = /*#__PURE__*/function (TOKENS) {
  TOKENS["background"] = "background";
  TOKENS["borderColor"] = "borderColor";
  TOKENS["iconColor"] = "iconColor";
  return TOKENS;
}(TOKENS || {});
export default TOKENS;